import DetailCards from './DetailCards';
import JobBasics from './JobBasics';
import JobSummary from './JobSummary';
import JobDescription from './JobDescription';
import JobMetrics from './JobMetrics';
import JobSummaryItem from './JobSummaryItem';
import JobTaskCards from './JobTaskCards';
import JobTaskCard from './JobTaskCard';

export {
  DetailCards,
  JobBasics,
  JobSummary,
  JobDescription,
  JobMetrics,
  JobSummaryItem,
  JobTaskCards,
  JobTaskCard
}



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/index.js